export default {
    /**
     * Datos añadidos a data por el mixin:
     * - nameTypesOptions: array con tipos de nombres
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            nameTypesOptions: []
        };
    },
    methods: {
        /**
         * Load Name types
         */
        loadNameTypesOptions() {
            const nameTypes = this.$t(`interveners.crs.type_name`);
            this.nameTypesOptions = Object.entries(nameTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de nombres en la variable
     * `this.nameTypesOptions`
     */
    beforeMount() {
        this.loadNameTypesOptions();
    }
};

